import { CookingPot } from "lucide-react";

export const ExitIntentHeader = () => {
  return (
    <div className="text-center space-y-4">
      <div className="flex justify-center mb-4">
        <CookingPot className="h-12 w-12 text-secondary" />
      </div>
      <h2 className="text-2xl font-mono font-bold">Hop là ! Avant de partir...</h2>
      <p className="text-gray-600">
        Laissez-nous votre email et obtenez :
      </p>
    </div>
  );
};